import { useState, useCallback, useEffect } from "react";

const STORAGE_KEY = "tripui-section-collapse";

const SECTION_DEFAULTS = {
  routeOptions: true,
  traffic: true,
  incidents: true,
  construction: true,
  weather: true,
  camera: true,
};

/**
 * Manages collapsible section expand/collapse state with localStorage persistence.
 * Returns the current state map, a toggle function, and a batch setter.
 */
const useSectionCollapse = () => {
  const [sections, setSections] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        const parsed = JSON.parse(stored);
        return { ...SECTION_DEFAULTS, ...parsed };
      }
    } catch {
      // ignore parse errors
    }
    return { ...SECTION_DEFAULTS };
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(sections));
    } catch {
      // ignore storage errors
    }
  }, [sections]);

  const toggleSection = useCallback((id) => {
    setSections((prev) => ({ ...prev, [id]: !prev[id] }));
  }, []);

  return { sections, toggleSection, setSections };
};

export default useSectionCollapse;
